
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Partners from './components/Partners';
import Benefits from './components/Benefits';
import Savings from './components/Savings';
import AppDownload from './components/AppDownload';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <HowItWorks />
      <Partners />
      <Benefits />
      <Savings />
      <AppDownload />
      <Footer />
      <FloatingCTA />
    </div>
  );
}
